import { ApiShopperLandingPage } from '@storefronts/common-types'
import { useMemo } from 'react'
import { CSSVariableSetter } from '../components/CSSVariableSetter'
import { GoogleFontLoader } from '../components/GoogleFontLoader'
import { LocalFontLoader } from '../components/LocalFontLoader'
import {
    CustomizationContext,
    DefaultCustomizationContext,
} from './customizationContext'

export { CustomizationContext }

export {
    PRIMARY_FONT_CSS_VAR,
    SECONDARY_FONT_CSS_VAR,
    FONT_3_CSS_VAR,
    FONT_4_CSS_VAR,
    FONT_5_CSS_VAR,
    PRIMARY_CTA_TEXT_COLOR_VAR,
    PRIMARY_CTA_FILL_COLOR_VAR,
    ACCENT_FILL_COLOR_VAR,
    ACCENT_TEXT_COLOR_VAR,
    PRIMARY_PAGE_FILL_COLOR_VAR,
    PRIMARY_PAGE_TEXT_COLOR_VAR,
    SECONDARY_CTA_TEXT_COLOR_VAR,
    SECONDARY_CTA_FILL_COLOR_VAR,
    TERTIARY_CTA_TEXT_COLOR_VAR,
    TERTIARY_CTA_FILL_COLOR_VAR,
    PRIMARY_DISCOUNT_COLOR_VAR,
    SECONDARY_DISCOUNT_COLOR_VAR,
    PRIMARY_ICON_COLOR_VAR,
    SUBTLE_BORDER_COLOR_VAR,
    SUBTLE_PRIMARY_COLOR_VAR,
    HEADER_BORDER_COLOR_VAR,
    PRIMARY_CTA_BORDER_VAR,
    SECONDARY_CTA_BORDER_VAR,
    TERTIARY_CTA_BORDER_VAR,
    BUTTON_BORDER_RADIUS_VAR,
    MEDIA_BORDER_RADIUS_VAR,
} from '@storefronts/common-types'

export const CustomizationContextProvider: React.FC<{
    children: React.ReactNode
    landingPage: ApiShopperLandingPage
}> = ({ children, landingPage }) => {
    const { settings } = landingPage
    // A stable value per settings object: CSSVariableSetter derives the
    // page's custom properties from it and only rewrites them when it changes.
    const customizationContext = useMemo<CustomizationContext>(
        () =>
            settings == null
                ? DefaultCustomizationContext
                : {
                      ...DefaultCustomizationContext,
                      ...settings,
                      primaryFontFamily:
                          settings.primaryFontFamily ??
                          DefaultCustomizationContext.primaryFontFamily,
                      secondaryFontFamily:
                          settings.secondaryFontFamily ??
                          DefaultCustomizationContext.secondaryFontFamily,
                  },
        [settings],
    )

    return (
        <CustomizationContext.Provider value={customizationContext}>
            <CSSVariableSetter />
            <GoogleFontLoader />
            <LocalFontLoader />
            {children}
        </CustomizationContext.Provider>
    )
}
